export const showroom = {
  section04: {
    item_01: {
      title: "Our Range",
      content:
        "Duyệt qua loạt mành, màn cửa và cửa chớp của chúng tôi và đặt mẫu miễn phí trước khi bạn đến showroom của Huy Hoàng",
    },
    item_02: {
      title: "Appointments",
      content: "Đặt hẹn với chúng tôi ngay khi bạn tìm được mẫu mã mình ưng ý.",
    },
    item_03: {
      title: "Many Options",
      content:
        "Sự lựa chọn cho mọi ngân sách, bao gồm mành kín, mành cách nhiệt và giải pháp cho sự riêng tư",
    },
    item_04: {
      title: "Flexible Appointments",
      content:
        "Thành phẩm chính xác ngay từ lần đầu tiên với sự đo đạc và lắp đặt bởi chuyên gia",
    },
    item_05: {
      title: "Multi-blind Discount",
      content: "Chính sách giảm giá của chúng tôi nới rộng ngân sách của bạn",
    },
    item_06: {
      title: "Expert Measuring",
      content:
        "Các cuộc hẹn được sắp xếp linh hoạt phù hợp với thời gian của bạn, bao gồm cả buổi tối và cuối tuần",
    },
  },
};
